import { render } from "./index.vue?vue&type=template&id=23e54a7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=23e54a7a&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=23e54a7a&lang=scss"

import exportComponent from "/Users/pengq/IdeaProjects/xin-sheng-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e54a7a"]])

export default __exports__